import React from "react";
import { useState } from "react";
import DownloadButton from "../../DownloadButton/DownloadButton";
import GalleryModal from "./../GalleryModal/GalleryModal";
import "./GalleryItem.css";

const GalleryItem = ({ item }) => {
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const showInfo = () => {
    setShow(true);
  };

  const hideInfo = () => {
    setShow(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  return (
    <>
      {item && (
        <GalleryModal show={showModal} handleClose={handleClose} item={item} />
      )}
      <div
        className="media-container"
        onMouseEnter={showInfo}
        onMouseLeave={hideInfo}
        onClick={handleShow}
      >
        <img className="img" src={item.coverUrl} alt="gallery item" />
        {item.type === "video" && (
          <div className="play-btn">
            <i className="bi bi-play-circle"></i>
          </div>
        )}
        <div className={`media-info top ${show ? "show-info" : ""}`}>
          <div>
            <span>
              <strong>{item.ship}</strong>{" "}
              {item.onboard
                ? Array.isArray(item.onboard)
                  ? item.onboard.join(", ")
                  : item.onboard
                : ""}
            </span>
          </div>
          <div>
            <span className="description">{item.description}</span>
          </div>
          <div>
            <span>
              {item.size} {item.format}
            </span>
          </div>
        </div>
        <div className={`media-info bottom ${show ? "show-info" : ""}`}>
          <DownloadButton item={item} />
        </div>
      </div>
    </>
  );
};

export default GalleryItem;
